import { useTranslator } from '@bluebeam/react-i18n';
import classnames from 'classnames';
import Search from 'components/Icons/Search';
import searchClear from 'images/icons/search-clear.svg';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import React, { FC } from 'react';
import { getRandomString } from 'utils/general';

interface Props {
  id: string;
  onChange: (searchString: string) => void;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  disableDebounce?: boolean;
  hideSearchIcon?: boolean;
}

const SearchInput: FC<Props> = ({
  onChange = noop,
  hideSearchIcon = false,
  placeholder: placeholderFromProps,
  value,
  disableDebounce,
  disabled,
}) => {
  const { translate } = useTranslator(['searchInput']);
  const placeholder =
    placeholderFromProps ?? translate('searchInput:placeholder');
  const id = getRandomString(8);
  const className = `search-input-${id}`;

  const onChangeDebounced = debounce((searchString: string): void => {
    onChange(searchString);
  }, 100);

  const handleSearchChange = (
    evt: React.ChangeEvent<HTMLInputElement>
  ): void => {
    if (disableDebounce) {
      onChange(evt.target.value);
    } else {
      onChangeDebounced(evt.target.value);
    }
  };

  return (
    <div
      id={id}
      className={classnames('search-wrapper hs2', {
        'cursor-not-allowed opacity-50': disabled,
      })}
      style={{
        border: 'solid 1px #d1d5de',
        borderRadius: '8px',
      }}
    >
      <style>
        {`
        .${className}::placeholder {
          font-size: 14px;
          color: #999;
        }

        #assignees-search [type="search"]::-webkit-search-cancel-button {
          -webkit-appearance: none;
          appearance: none;
          height: 16px;
          width: 16px;
          background-image: url(${searchClear});
          background-size: 16px 16px;
        }
        `}
      </style>
      <div className="row items-center">
        <div
          className="ws2 flex-center"
          style={{ display: hideSearchIcon ? 'none' : 'flex' }}
        >
          <Search width="12px" height="12px" style={{ fill: '#7C8385' }} />
        </div>
        <input
          disabled={disabled}
          id={`${id}-input`}
          value={value}
          type="search"
          placeholder={placeholder}
          className={`${className} font-size-4 light`}
          style={{
            width: '100%',
            height: '30px',
            paddingRight: '.5rem',
            border: 'transparent',
            borderRadius: '8px',
            outline: 'none',
            paddingLeft: hideSearchIcon ? '16px' : '0px',
          }}
          onChange={handleSearchChange}
        />
      </div>
    </div>
  );
};

export default SearchInput;
